"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppError = exports.SEVERITY_TO_LEVEL = void 0;
exports.severityToLevel = severityToLevel;
/**
 * Severity → Sentry event `level` mapping.
 * - sev1 → fatal  (user-blocking / product broken — triggers ntfy phone push)
 * - sev2 → error  (background degradation — worker retries absorb it)
 * - sev3 → warning (expected 4xx — user-facing edge cases)
 */
exports.SEVERITY_TO_LEVEL = {
    sev1: 'fatal',
    sev2: 'error',
    sev3: 'warning',
};
function severityToLevel(s) {
    return exports.SEVERITY_TO_LEVEL[s];
}
/**
 * Abstract base class. All thrown errors across the stack MUST be an instance
 * of a subclass of `AppError` (enforced by `@typescript-eslint/only-throw-error`
 * in Plan 05).
 *
 * - `severity` is a STATIC readonly property on the concrete subclass.
 * - `httpStatus` (optional static) lets the Plan 04 SanitizingExceptionFilter
 *   derive HTTP status codes without per-site overrides during Plan 09's hard
 *   cutover (critical for 401/403 preservation via AuthError/PermissionError).
 * - The instance getter `severity` bridges back to the class property so
 *   callers can `err.severity` without a cast.
 */
class AppError extends Error {
    static severity;
    static httpStatus;
    /**
     * Phase quick-260426-x4h Task A — capture-opt-out flag.
     *
     * Defaults to `true`: every AppError subclass is captured in Sentry. A
     * subclass that represents an EXPECTED retry condition (e.g. CRM's
     * PrerequisiteMissingError, where the upstream event will commit within
     * a few Pub/Sub redelivery cycles) overrides this to `false` so the
     * trace+log path keeps working but Sentry doesn't see a redelivery
     * storm. The consumer/forwarder still NACKs the message — the DLQ
     * budget remains the safety net.
     */
    static captureInSentry = true;
    code;
    details;
    userMessage;
    constructor(args) {
        super(args.message);
        this.name = new.target.name;
        this.code = args.code;
        this.details = args.details ?? {};
        this.userMessage = args.userMessage;
    }
    get severity() {
        return this.constructor.severity;
    }
    get sentryLevel() {
        return exports.SEVERITY_TO_LEVEL[this.severity];
    }
    /**
     * Instance bridge to the static `captureInSentry` flag — lets callers
     * write `if (err.captureInSentry)` without a class cast.
     */
    get captureInSentry() {
        return this.constructor.captureInSentry;
    }
}
exports.AppError = AppError;
